import { useTranslation } from 'react-i18next';
import LessonRouter from './LessonRouter';

function Lesson() {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-12 bg-grey-super_light min-h-screen">
      <div className="col-span-12 lg:col-span-12 mx-2 lg:mx-12">
        <LessonRouter />
      </div>
    </div>
  );
}

Lesson.propTypes = {};

export default Lesson;
